import { useState } from "react";
import "./product-small-image-slider.component.styles.css";

const ProductSmallImageSlider = ({ images, onThumbnailClick }) => {
  const [startIndex, setStartIndex] = useState(0);
  const visibleImages = images.slice(startIndex, startIndex + 3);

  // برای کنترل حرکت کشیدن
  const [isDragging, setIsDragging] = useState(false);
  const [dragStartX, setDragStartX] = useState(0);

  // آستانه حرکت برای تغییر اسلاید (بر حسب پیکسل)
  const threshold = 50;

  const handlePrev = () => {
    if (startIndex > 0) {
      setStartIndex((prev) => prev - 1);
    }
  };

  const handleNext = () => {
    if (startIndex + 3 < images.length) {
      setStartIndex((prev) => prev + 1);
    } else {
      setStartIndex(images.length - 3); // نمایش آخرین ۳ عکس به‌طور کامل
    }
  };

  // رویداد شروع کشیدن (پایین نگه داشتن ماوس/لمس)
  const handlePointerDown = (e) => {
    setIsDragging(true);
    setDragStartX(e.clientX || e.touches?.[0]?.clientX || 0);
  };

  // رویداد حرکت در هنگام کشیدن
  const handlePointerMove = (e) => {
    // اگر در حال کشیدن نیستیم، کاری نکن
    if (!isDragging) return;
    // اینجا می‌توانید در صورت تمایل افکت بصری ایجاد کنید،
    // اما فعلاً تصمیم به تغییر اسلاید را تا pointerUp به تعویق می‌اندازیم.
  };

  // رویداد رها کردن (بالا آمدن ماوس/پایان لمس)
  const handlePointerUp = (e) => {
    if (!isDragging) return;
    setIsDragging(false);

    // محاسبه فاصلهٔ حرکت
    const endX = e.clientX || e.changedTouches?.[0]?.clientX || 0;
    const diff = endX - dragStartX;

    if (diff > threshold) {
      // کشیدن به سمت راست -> نمایش تصویر قبلی
      handlePrev();
    } else if (diff < -threshold) {
      // کشیدن به سمت چپ -> نمایش تصویر بعدی
      handleNext();
    }
  };

  // اگر نشانگر از محدوده خارج شد، بلافاصله کشیدن را متوقف می‌کنیم
  const handlePointerLeave = () => {
    setIsDragging(false);
  };

  return (
    <div className="product-small-slider">
      <div className="product-small-slider-content-wrapper">
        <button
          className="product-small-slider-per-button product-small-slider-button"
          onClick={handlePrev}
          disabled={startIndex === 0}
        >
          {"<"}
        </button>

        <div
          className="product-small-imgs-wrapper"
          style={{ touchAction: "none", userSelect: "none" }}
          onPointerDown={handlePointerDown}
          onPointerMove={handlePointerMove}
          onPointerUp={handlePointerUp}
          onPointerLeave={handlePointerLeave}
          // برای موبایل‌های قدیمی‌تر که از PointerEvents پشتیبانی نمی‌کنند
          onTouchStart={handlePointerDown}
          onTouchMove={handlePointerMove}
          onTouchEnd={handlePointerUp}
        >
          {visibleImages.map((img, index) => (
            <div className="product-small-img-wrapper" key={`${img}-${index}`}>
              <img
                src={img}
                alt={`Small preview ${index + 1}`}
                className="product-page-small-img"
                onClick={() => {
                  // اگر در حال کشیدن نبوده‌ایم، رویداد کلیک انجام شود
                  if (!isDragging) {
                    onThumbnailClick(startIndex + index);
                  }
                }}
              />
            </div>
          ))}
        </div>

        <button
          className="product-small-slider-nex-button product-small-slider-button"
          onClick={handleNext}
          disabled={startIndex + 3 >= images.length}
        >
          {">"}
        </button>
      </div>
    </div>
  );
};

export default ProductSmallImageSlider;
